var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"dark":""}},[_c('toolbar-main',{attrs:{"toolbarTitle":_vm.pageName,"extension":'extension'}}),_vm._v(" "),_c('v-content',[_c('router-view')],1),_vm._v(" "),_c('v-footer',{staticClass:"justify-center",attrs:{"absolute":"","app":""}},[_c('span',[_vm._v("\n      © 2018 - AmmoNyte Systems LLC\n    ")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2baaf466","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 265
// module chunks = 1